export const ArrowDownIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.52823 7.96359L6.52823 2.74334L9.6603 2.74334L9.6603 7.9636L13.3145 7.96347L8.09433 13.1836L2.8742 7.96347L6.52823 7.96359Z"
        fill="#FF4343"
      />
    </svg>
  );
};
